// extracted by mini-css-extract-plugin
export default {"root":"root--FGZQw","body":"body--lMNFX","preview":"preview--NX4vv","footer":"footer--EEo8h","meta":"meta--M6tQM","gap":"gap--ITaUv","size":"size--Y4LVX"};